let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9G5fi")).then(() => parcelRequire('1xaCx'));